import { shopGrid as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

export const shopGroupPageArr = [
  {
    image: '/assets/textimageplaceholder.png',
    title: 'Bigfork',
    address: '459 Electric Avenue, Bigfork, MT 59911',
    phone: '(406) 420-2302',
    breNumber: '01910946',
    urlWebsite: 'https://www.engelvoelkers.com/en/',
    urlAdvisors: 'https://www.engelvoelkers.com/en/',
    urlFacebook: 'https://www.engelvoelkers.com/en/',
    urlTwitter: 'https://www.engelvoelkers.com/en/',
    urlLinkedin: 'https://www.engelvoelkers.com/en/',
    urlInstagram: 'https://www.engelvoelkers.com/en/',
    urlYoutube: 'https://www.engelvoelkers.com/en/',
    urlTiktok: 'https://www.engelvoelkers.com/en/',
  },
  {
    image: '/assets/textimageplaceholder.png',
    title: 'Cohasset',
    address: '62229 Mills Flats',
    phone: '(873) 497-7069',
    breNumber: 56171568,
    urlWebsite: 'https://www.engelvoelkers.com/en/',
    urlAdvisors: null,
    urlFacebook: 'https://www.engelvoelkers.com/en/',
    urlTwitter: 'https://www.engelvoelkers.com/en/',
    urlLinkedIn: 'https://www.engelvoelkers.com/en/',
    urlInstagram: 'https://www.engelvoelkers.com/en/',
    urlYoutube: null,
    urlTiktok: 'https://www.engelvoelkers.com/en/',
  },
  {
    image: '/assets/textimageplaceholder.png',
    title: 'Bernardsville',
    address: '78282 Bridgette Parks',
    phone: '(898) 176-2939',
    breNumber: 29298314,
    urlWebsite: 'https://www.engelvoelkers.com/en/',
    urlAdvisors: 'https://www.engelvoelkers.com/en/',
    urlFacebook: 'https://www.engelvoelkers.com/en/',
    urlTwitter: 'https://www.engelvoelkers.com/en/',
    urlLinkedIn: 'https://www.engelvoelkers.com/en/',
    urlInstagram: 'https://www.engelvoelkers.com/en/',
    urlYoutube: null,
    urlTiktok: null,
  },
  {
    image: '/assets/textimageplaceholder.png',
    title: 'Ellington',
    address: '92452 Granville Shore',
    phone: '(068) 193-8044',
    breNumber: 48305748,
    urlWebsite: 'https://www.engelvoelkers.com/en/',
    urlAdvisors: 'https://www.engelvoelkers.com/en/',
    urlFacebook: 'https://www.engelvoelkers.com/en/',
    urlTwitter: null,
    urlLinkedIn: 'https://www.engelvoelkers.com/en/',
    urlInstagram: 'https://www.engelvoelkers.com/en/',
    urlYoutube: 'https://www.engelvoelkers.com/en/',
    urlTiktok: 'https://www.engelvoelkers.com/en/',
  },
  {
    image: '/assets/textimageplaceholder.png',
    title: 'Oakley',
    address: '210 Schmeler Harbors',
    phone: '(939) 583-5872',
    breNumber: 32520370,
    urlWebsite: 'https://www.engelvoelkers.com/en/',
    urlAdvisors: 'https://www.engelvoelkers.com/en/',
    urlFacebook: 'https://www.engelvoelkers.com/en/',
    urlTwitter: 'https://www.engelvoelkers.com/en/',
    urlLinkedIn: 'https://www.engelvoelkers.com/en/',
    urlInstagram: null,
    urlYoutube: null,
    urlTiktok: null,
  },
  {
    image: '/assets/textimageplaceholder.png',
    title: 'Chicago',
    address: '2926 W Belden Ave',
    phone: '(898) 176-2939',
    breNumber: 29298314,
    urlWebsite: 'https://www.engelvoelkers.com/en/',
    urlAdvisors: 'https://www.engelvoelkers.com/en/',
    urlFacebook: 'https://www.engelvoelkers.com/en/',
    urlTwitter: 'https://www.engelvoelkers.com/en/',
    urlLinkedIn: 'https://www.engelvoelkers.com/en/',
    urlInstagram: 'https://www.engelvoelkers.com/en/',
    urlYoutube: null,
    urlTiktok: null,
  },
];

const TestData = {
  ourLocalShopsHeadline: 'Test Header',
  shopIds: '1,2,3,4,5,6',
};

export default fakeProps(schema, TestData);
